export function GenericWidget({ data }: { data: Record<string, unknown> }) {
  const content = (data.content ?? data.text ?? data.markdown ?? "") as string;

  if (!content && Object.keys(data).length > 0) {
    // Render raw data as formatted JSON
    return (
      <pre className="text-xs text-gray-400 whitespace-pre-wrap font-mono">
        {JSON.stringify(data, null, 2)}
      </pre>
    );
  }

  return (
    <div className="whitespace-pre-wrap text-gray-300 text-sm leading-relaxed">
      {content || "No content"}
    </div>
  );
}
